import { render } from "./MovieTrailer.vue?vue&type=template&id=c2894c12&scoped=true"
import script from "./MovieTrailer.vue?vue&type=script&lang=js"
export * from "./MovieTrailer.vue?vue&type=script&lang=js"

import "./MovieTrailer.vue?vue&type=style&index=0&id=c2894c12&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2894c12"]])

export default __exports__